import React, { Component } from "react";
import AdvancedCommonFileSettings from "./AdvancedCommonFileSettings";

export class AdvancedDropboxSettings extends Component {
  state = {
    onlyReadSettings: [],
    doNotReadSettings: [],
    doNotSpiderSettings: [],
    childSettings: [],
  };

  componentDidMount() {
    // this.settingsUpdated();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      // this.settingsUpdated();
    }
  }

  render() {
    return (
      <div>
        <AdvancedCommonFileSettings
          editKs={this.props.editKs}
          setSpiderProperties={this.props.setSpiderProperties}
          sourceType="DROPBOX"
        />
      </div>
    );
  }

  // settingsUpdated = () => {
  //   let settings = this.state.childSettings.concat(
  //     this.state.onlyReadSettings,
  //     this.state.doNotReadSettings,
  //     this.state.doNotSpiderSettings
  //   );
  //   this.props.setSettings(settings);
  // };

  setChildSettings = (childSettings) => {
    this.setState({ childSettings });
  };
}

export default AdvancedDropboxSettings;
